module.exports = __webpack_public_path__ + "static/media/eac.32ef8dde.svg";